'use client'
import {
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import {
  ButtonProps,
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

import NewsletterButton from '@/components/atoms/Buttons/NewsletterButton'

export interface NewsletterProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    cta: ButtonProps
  }
}

const Newsletter = ({ modelledContent }: NewsletterProps) => {
  const { openingTitle, title, paragraph, cta } = modelledContent

  return (
    <Section className='section-newsletter'>
      <div className='section-wrapper'>
        <div className='section-intro'>
          <OpeningTitle {...openingTitle}>{openingTitle.content}</OpeningTitle>
          <div className='section-intro--content'>
            <Title
              {...title}
              dangerouslySetInnerHTML={{ __html: title.content || '' }}
            />
          </div>
        </div>

        <div className='section-content'>
          <div className='section-newsletter--cta'>
            <Paragraph
              className='section-newsletter--cta--paragraph'
              as={'div'}
              dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
            />
            <NewsletterButton {...cta} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default Newsletter
